"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var formik_1 = require("formik");

var react_i18next_1 = require("react-i18next");

var react_web_components_1 = require("@nimles/react-web-components");

var fields_1 = require("../fields");

exports.UserForm = function (_a) {
  var user = _a.user,
      onSubmit = _a.onSubmit;
  var values = {
    username: user && user.username,
    id: user && user.id,
    firstName: user && user.firstName,
    lastName: user && user.lastName,
    phoneNumber: user && user.phoneNumber || '',
    address: {
      street: user && user.address && user.address.street || '',
      postalCode: user && user.address && user.address.postalCode || '',
      city: user && user.address && user.address.city || ''
    }
  };
  var t = react_i18next_1.useTranslation().t;

  var handleSubmit = function handleSubmit(values, _a) {
    var setSubmitting = _a.setSubmitting,
        setErrors = _a.setErrors,
        setStatus = _a.setStatus;

    try {
      onSubmit(values);
      setSubmitting(false);
      setStatus({
        success: true
      });
    } catch (error) {
      setStatus({
        success: false
      });
      setSubmitting(false);
      setErrors({
        submit: error.message
      });
    }
  };

  return react_1.default.createElement(formik_1.Formik, {
    initialValues: values,
    onSubmit: handleSubmit,
    render: function render(_a) {
      var values = _a.values,
          handleSubmit = _a.handleSubmit,
          isSubmitting = _a.isSubmitting;
      return react_1.default.createElement("form", {
        onSubmit: handleSubmit,
        noValidate: true,
        name: "simpleForm",
        className: "user-form"
      }, react_1.default.createElement(react_web_components_1.Row, {
        wrap: "wrap",
        className: "user-form__name"
      }, react_1.default.createElement(react_web_components_1.Column, {
        xs: 100,
        sm: 50
      }, react_1.default.createElement(fields_1.InputField, {
        name: "firstName",
        label: t('prop.firstName')
      })), react_1.default.createElement(react_web_components_1.Column, {
        xs: 100,
        sm: 50
      }, react_1.default.createElement(fields_1.InputField, {
        name: "lastName",
        label: t('prop.lastName')
      }))), react_1.default.createElement(react_web_components_1.Row, null, react_1.default.createElement(react_web_components_1.Column, {
        xs: 100
      }, react_1.default.createElement(fields_1.InputField, {
        name: "phoneNumber",
        label: t('prop.phoneNumber')
      }))), react_1.default.createElement(react_web_components_1.Row, null, react_1.default.createElement(react_web_components_1.Column, {
        xs: 100
      }, react_1.default.createElement(fields_1.InputField, {
        name: "address.street",
        label: t('prop.street')
      }))), react_1.default.createElement(react_web_components_1.Row, {
        wrap: "wrap"
      }, react_1.default.createElement(react_web_components_1.Column, {
        xs: 100,
        sm: 50
      }, react_1.default.createElement(fields_1.InputField, {
        name: "address.postalCode",
        label: t('prop.postalCode')
      })), react_1.default.createElement(react_web_components_1.Column, {
        xs: 100,
        sm: 50
      }, react_1.default.createElement(fields_1.InputField, {
        name: "address.city",
        label: t('prop.city')
      }))), react_1.default.createElement(react_web_components_1.Row, {
        justify: "flex-end",
        margin: "10px -15px 0"
      }, react_1.default.createElement(react_web_components_1.Column, null, react_1.default.createElement(react_web_components_1.Button, {
        raised: true,
        primary: true,
        type: "submit"
      }, t(isSubmitting ? 'action.saving' : 'action.save')))));
    }
  });
};